import {
  MOVE_TO_TRASH_PENDING,
  MOVE_TO_TRASH_SUCCESS,
  MOVE_TO_TRASH_ERROR,
  RESTORED_FROM_TRASH_PENDING,
  RESTORED_FROM_TRASH_SUCCESS,
  RESTORED_FROM_TRASH_ERROR,
  PERMANENTLY_DELETE_LOADING,
  PERMANENTLY_DELETE_SUCCESS,
  PERMANENTLY_DELETE_ERROR,
} from "~/store/action_types";
import Angie from "~/utils/angie.jsx";
import { fetch } from "~/utils/fetch.jsx";

export const moveToTrash = (type, id, attributes) => {
  const slug = Angie.functions.slug(type);
  return {
    types: [MOVE_TO_TRASH_PENDING, MOVE_TO_TRASH_SUCCESS, MOVE_TO_TRASH_ERROR],
    callAPI: () =>
      fetch({
        url: `${Angie.api_url}/move-to-trash/${slug}/${id}`,
        method: `put`,
        body: attributes,
      }),
    payload: {
      objectType: type,
      id,
      attributes,
    },
  };
};

export const restoredFromTrash = (type, id) => {
  const slug = Angie.functions.slug(type);
  return {
    types: [RESTORED_FROM_TRASH_PENDING, RESTORED_FROM_TRASH_SUCCESS, RESTORED_FROM_TRASH_ERROR],
    callAPI: () =>
      fetch({
        url: `${Angie.api_url}/restore-from-trash/${slug}/${id}`,
        method: `put`,
      }),
    payload: {
      objectType: type,
      id,
    },
  };
};

export const permanentlyDelete = (type, id) => {
  const slug = Angie.functions.slug(type);
  return {
    types: [PERMANENTLY_DELETE_LOADING, PERMANENTLY_DELETE_SUCCESS, PERMANENTLY_DELETE_ERROR],
    callAPI: () =>
      fetch({
        url: `${Angie.api_url}/permanently-delete/${slug}/${id}`,
        method: `delete`,
      }),
    payload: {
      objectType: type,
      id,
    },
  };
};
